import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchOperationVerificationApplications } from '@/lib/venue/operationVerificationApi'

/**
 * EP-2 — 운영 인증 이력(회차) 목록(`#778`, 백엔드 `#777` §3) — 커서 페이지네이션.
 * `useVenueReservationSettingHistories`와 같은 패턴 — 서버가 이미 인코딩된 `nextCursor`를 주므로
 * `getNextPageParam`을 직접 선언한다.
 */
export function useOperationVerificationApplications(venueId: string) {
  return useInfiniteQuery({
    queryKey: ['venue', venueId, 'operation-verification', 'applications'] as const,
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchOperationVerificationApplications(venueId, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}
